// STUB — to be replaced by the audio agent. Must export `AudioSystem`.
import type { IAudioSystem, IRadioStation, IVehicle, SfxId } from './types';

export class AudioSystem implements IAudioSystem {
  stations: IRadioStation[] = [
    { name: 'Danube FM', genre: 'synthwave' },
    { name: 'Pest Bass', genre: 'trap' },
    { name: 'Buda Classic', genre: 'ambient' },
  ];
  station: IRadioStation = this.stations[0];
  volumes = { master: 0.8, sfx: 1, music: 0.6 };
  unlock(): void {}
  play(id: SfxId, x?: number, z?: number, gain?: number): void {
    void id; void x; void z; void gain;
  }
  setEngine(vehicle: IVehicle | null): void {
    void vehicle;
  }
  setSirens(vehicles: IVehicle[]): void {
    void vehicles;
  }
  setRadioOn(on: boolean): void {
    void on;
  }
  nextStation(): IRadioStation {
    const i = (this.stations.indexOf(this.station) + 1) % this.stations.length;
    this.station = this.stations[i];
    return this.station;
  }
  update(dt: number): void {
    void dt;
  }
}
